module.exports = __webpack_public_path__ + "static/img/banner_03.ef21733.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner/banner_03.jpg
// module id = 6qJe
// module chunks = 9